export const SET_STATES_DATA = 'SET_STATES_DATA';



// WEBPACK FOOTER //
// ./src/store/reducers/states/actionTypes.js